import { createTrackingEmitterHooks } from "@b2bportal/core-tracking";
import type { Reservation } from "@b2bportal/lodging-api";

export type HotelBookingTrackingProperties = {
  properties: {
    advance: number;
    check_in_date: string;
    check_out_date: string;
    feature_type: string;
    booking_date: string;
    days_since_booking: number;
    reservation_id: string;
    room_count: number;
  };
};

export const fallbackHotelBookingTrackingProperties = {
  properties: {
    advance: 0,
    check_in_date: "",
    check_out_date: "",
    feature_type: "hotels",
    booking_date: "",
    days_since_booking: 0,
    reservation_id: "",
    room_count: 0,
  },
};

export type TripsRawEvent =
  | ViewedMyTripsRawEvent
  | ViewedTripSummaryHotelRawEvent
  | TappedCancelHotelRawEvent
  | ViewCancelModalHotelRawEvent
  | TappedConfirmCancelHotelRawEvent
  | TappedCancelGoBackHotelRawEvent
  | TappedContactSupportHotelRawEvent
  | TappedCallContactSupportHotelRawEvent
  | CompleteCancelSuccessHotelRawEvent
  | CompleteCancelFailureHotelRawEvent;

export enum TripsRawEventName {
  ViewedMyTrips = "ViewedMyTrips",
  ViewedTripSummaryHotel = "ViewedTripSummaryHotel",
  TappedCancelHotel = "TappedCancelHotel",
  ViewCancelModalHotel = "ViewCancelModalHotel",
  TappedConfirmCancelHotel = "TappedConfirmCancelHotel",
  TappedCancelGoBackHotel = "TappedCancelGoBackHotel",
  TappedContactSupportHotel = "TappedContactSupportHotel",
  TappedCallContactSupportHotel = "TappedCallContactSupportHotel",
  CompleteCancelSuccessHotel = "CompleteCancelSuccessHotel",
  CompleteCancelFailureHotel = "CompleteCancelFailureHotel",
}

export type ViewedMyTripsRawEvent = {
  name: TripsRawEventName.ViewedMyTrips;
};

export type HotelReservationEventType = {
  hotelReservation: Reservation;
};

export type ViewedTripSummaryHotelRawEvent = {
  name: TripsRawEventName.ViewedTripSummaryHotel;
};

export type TappedCancelHotelRawEvent = {
  name: TripsRawEventName.TappedCancelHotel;
};

export type ViewCancelModalHotelRawEvent = {
  name: TripsRawEventName.ViewCancelModalHotel;
};

export type TappedConfirmCancelHotelRawEvent = {
  name: TripsRawEventName.TappedConfirmCancelHotel;
};

export type TappedCancelGoBackHotelRawEvent = {
  name: TripsRawEventName.TappedCancelGoBackHotel;
};

export type TappedContactSupportHotelRawEvent = {
  name: TripsRawEventName.TappedContactSupportHotel;
};

export type TappedCallContactSupportHotelRawEvent = {
  name: TripsRawEventName.TappedCallContactSupportHotel;
};

export type CompleteCancelSuccessHotelRawEvent = {
  name: TripsRawEventName.CompleteCancelSuccessHotel;
};

export type CompleteCancelFailureHotelRawEvent = {
  name: TripsRawEventName.CompleteCancelFailureHotel;
};

export const {
  useEmitRawEvent: useEmitCoreTripsRawEvent,
  useEmitRawEventOnce: useEmitCoreTripsRawEventOnce,
} = createTrackingEmitterHooks<TripsRawEvent>();
